import './WidgetTemplatesPage.css';

import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import { Box } from '@mui/material';
import Banner from '../../b2b-common/Banner';
import { useEffect, useState } from 'react';
import useWidgetTemplates from '../hooks/useWidgetTemplates';
import WidgetTemplatesTable from '../components/widget-templates/WidgetTemplatesTable';
import WidgetTemplateEditForm from '../forms/WidgetTemplateEditForm';

const WidgetTemplatesPage = () => {
    const { t } = useB2BTranslation('b2b-reporting');
    const [selectedWidgetTemplate, setSelectedWidgetTemplate] = useState(null);
    const [showWidgetTemplateEditForm, setShowWidgetTemplateEditForm] = useState(false);
    const { getAllWidgetTemplates } = useWidgetTemplates();

    const [widgetTemplates, setWidgetTemplates] = useState(null);

    useEffect(() => {
        if (widgetTemplates === null) {
            (async () => {
                const templates = await getAllWidgetTemplates();
                setWidgetTemplates(templates);
            })();
        }
    }, []);

    const handleNewWidgetTemplate = () => {
        setSelectedWidgetTemplate(null);
        setShowWidgetTemplateEditForm(true);
    }

    const handleSelectWidgetTemplate = (widgetTemplate) => {
        setSelectedWidgetTemplate(widgetTemplate);
        setShowWidgetTemplateEditForm(true);
    }

    const handleSavedWidgetTemplate = (savedWidgetTemplate) => {
        setShowWidgetTemplateEditForm(false);
        const widgetTemplateIndex = widgetTemplates.findIndex(widgetTemplate => widgetTemplate.id === savedWidgetTemplate.id);
        if (widgetTemplateIndex !== -1) {
            // Update existing widget template
            const updatedWidgetTemplates = [...widgetTemplates];
            updatedWidgetTemplates[widgetTemplateIndex] = savedWidgetTemplate;
            setWidgetTemplates(updatedWidgetTemplates);
        } else {
            // Add new widget template
            setWidgetTemplates([...widgetTemplates, savedWidgetTemplate]);
        }
    }

    const handleDeletedWidgetTemplate = async (widgetTemplate) => {
        setShowWidgetTemplateEditForm(false);
        const newWidgetTemplates = widgetTemplates.filter((t) => t.id !== widgetTemplate.id);
        setWidgetTemplates(newWidgetTemplates);
    }

    return (
        <Box className="widget-templates-page"
            width={'100%'} height="100%" display="flex" flexDirection="column" gap={2}
            justifyContent="flex-start" alignItems="center" 
        >
            <Banner sectionTittle={t('Widget Templates')} message={t('Manage your widget templates here.')} />
            <Box width={'100%'}>
                <WidgetTemplatesTable
                    templates={widgetTemplates}
                    onNewTemplate={handleNewWidgetTemplate}
                    onSelect={handleSelectWidgetTemplate}
                />
            </Box>
            {showWidgetTemplateEditForm && (
                <WidgetTemplateEditForm
                    template={selectedWidgetTemplate}
                    onSave={handleSavedWidgetTemplate}
                    onDelete={handleDeletedWidgetTemplate}
                    onCancel={() => setShowWidgetTemplateEditForm(false)}
                />
            )}
        </Box>
    );
}

export default WidgetTemplatesPage;